import { pawnShopGameBlemishI, pawnShopGameBlemishMap, pawnShopGameObjI, pawnShopGameObjMap, pawnShopObjQualityE, pawnShopObjTypeE } from "../const/pawnShopConst";

let pawnShopObjs:pawnShopGameObjI[][] = null;

let pawnShopObjMap:pawnShopGameObjMap = null;

/**
 * 获取鉴宝中的所有品质的所有物品
 */
export function getPawnShopObjs(){
    if(!pawnShopObjs){
        pawnShopObjs = [
            // [
            //     {id:"10011",name:"青花瓷花瓶",prefabPath:"obj_1",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.broken,price:500,bindBackId:10011,weight:21,buyFindObjs:["10011","10012","10013","10014","10015"],canFix:true},
            //     {id:"10021",name:"裘皮大衣",prefabPath:"obj_2",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.broken,price:580,bindBackId:10021,weight:21,buyFindObjs:["10021","10022","10023","10024"]},
            //     {id:"10031",name:"家传古画",prefabPath:"obj_3",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.broken,price:880,bindBackId:10031,weight:21,buyFindObjs:["10031","10032","10033","10034"]},
            //     {id:"10041",name:"尿瓶",prefabPath:"obj_4",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.broken,price:880,bindBackId:10041,weight:21,buyFindObjs:["10041","10042","10043"],canFix:true},
            //     {id:"10051",name:"鎏金盔甲",prefabPath:"obj_5",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.broken,price:1500,bindBackId:10051,weight:11,buyFindObjs:["10051","10052","10053","10054"]},
            //     {id:"10061",name:"传国玉玺",prefabPath:"obj_6",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.broken,price:3900,bindBackId:10061,weight:5,buyFindObjs:["10061","10062","10063","10064"]},
            // ],
            // [
            //     {id:"10012",name:"青花瓷花瓶",prefabPath:"obj_1",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.blemish,price:1999,bindBackId:10012,weight:21,buyFindObjs:["10011","10012","10013","10014","10015"],canFix:true},
            //     {id:"10022",name:"裘皮大衣",prefabPath:"obj_2",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.blemish,price:2200,bindBackId:10022,weight:21,buyFindObjs:["10021","10022","10023","10024"]},
            //     {id:"10032",name:"家传古画",prefabPath:"obj_3",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.blemish,price:3800,bindBackId:10032,weight:21,buyFindObjs:["10031","10032","10033","10034"]},
            //     {id:"10042",name:"尿瓶",prefabPath:"obj_4",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.blemish,price:6800,bindBackId:10042,weight:21,buyFindObjs:["10041","10042","10043"],canFix:true},
            //     {id:"10052",name:"鎏金盔甲",prefabPath:"obj_5",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.blemish,price:9800,bindBackId:10052,weight:11,buyFindObjs:["10051","10052","10053","10054"]},
            //     {id:"10062",name:"传国玉玺",prefabPath:"obj_6",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.blemish,price:9999,bindBackId:10062,weight:5,buyFindObjs:["10061","10062","10063","10064"]},
            // ],
            // [
            //     {id:"10013",name:"青花瓷花瓶",prefabPath:"obj_1",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.intact,price:9999,bindBackId:10013,weight:21,buyFindObjs:["10011","10012","10013","10014","10015"],canFix:true},
            //     {id:"10023",name:"裘皮大衣",prefabPath:"obj_2",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.intact,price:13500,bindBackId:10023,weight:21,buyFindObjs:["10021","10022","10023","10024"]},
            //     {id:"10033",name:"家传古画",prefabPath:"obj_3",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.intact,price:19800,bindBackId:10033,weight:21,buyFindObjs:["10031","10032","10033","10034"]},
            //     {id:"10043",name:"尿瓶",prefabPath:"obj_4",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.intact,price:28000,bindBackId:10043,weight:21,buyFindObjs:["10041","10042","10043"],canFix:true},
            //     {id:"10053",name:"鎏金盔甲",prefabPath:"obj_5",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.intact,price:35900,bindBackId:10053,weight:21,buyFindObjs:["10051","10052","10053","10054"]},
            //     {id:"10063",name:"传国玉玺",prefabPath:"obj_6",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.intact,price:38000,bindBackId:10063,weight:5,buyFindObjs:["10061","10062","10063","10064"]},
            // ],
            // [
            //     {id:"10054",name:"鎏金盔甲",prefabPath:"obj_5",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.best,price:500,bindBackId:10054,weight:70,buyFindObjs:["10051","10052","10053","10054"]},
            //     {id:"10064",name:"传国玉玺",prefabPath:"obj_6",type:pawnShopObjTypeE.normal,quality:pawnShopObjQualityE.best,price:500,bindBackId:10064,weight:30,buyFindObjs:["10061","10062","10063","10064"]},
            // ]
        ]
    }
    return pawnShopObjs;
}

//获取鉴宝中所有品质所有物品的map
export function getpawnShopObjMap(){
    if(!pawnShopObjMap){
        pawnShopObjMap = <pawnShopGameObjMap>{};
        let allObjs = getPawnShopObjs();
        for(let i =0;i<allObjs.length;i++){
            let alls = allObjs[i];
            for(let j = 0;j < alls.length;j++){
                let obj = alls[j];
                pawnShopObjMap[obj.id] = obj;
            }
        }
    }
    return pawnShopObjMap;
}

//获取鉴宝中指定品质的所有物品
export function getPawnShopObjByQuality(quality:pawnShopObjQualityE){
    return getPawnShopObjs()[quality];
}

//通过id获取鉴宝中的物品
export function getPawnShopGameObjById(id:string){
    return getpawnShopObjMap()[id];
}

let blemishAry:pawnShopGameBlemishI[] = null;

//获取鉴宝中的所有瑕疵
export function getPawnShopBlemishAry(){
    if(!blemishAry){
        blemishAry = [
            {id:"10011",name:"一坨很小的答辩",influencePrice:-300,findExplain:["你没听过依托答辩？给你减一点"]},
            {id:"10012",name:"made in China",influencePrice:-30,findExplain:["这才叫根正苗红！"]},
            {id:"10013",name:"莲花花纹里有个人撒尿",influencePrice:-20,findExplain:["你是眼花了吧"]},
            {id:"10014",name:"底座有个小洞",influencePrice:-50,findExplain:["不小心被磕了，别人也看不见的"]},
            {id:"10015",name:"瓶身裂纹",influencePrice:-30,findExplain:["一点小裂纹而已，别那么在乎"]},

            {id:"10021",name:"鸡打篮球",influencePrice:50,findExplain:["这是什么图案，没见过啊？"]},
            {id:"10022",name:"辣椒油渍",influencePrice:-30,findExplain:["刚刚吃饭不小心沾了一点，没事的"]},
            {id:"10023",name:"破洞",influencePrice:-50,findExplain:["谁家衣服还没点补丁吗"]},
            {id:"10024",name:"鸡毛",influencePrice:-200,findExplain:["鸡毛也是毛啊，那给你少点好啦"]},

            {id:"10031",name:"鸡踢蹴鞠",influencePrice:-50,findExplain:["别人致敬一下偶像都不行？"]},
            {id:"10032",name:"印记",influencePrice:-50,findExplain:["一不小心掉上去的嘛，理解一下"]},
            {id:"10033",name:"卫生纸",influencePrice:-200,findExplain:["画布不够了，纸也不是不行吧"]},
            {id:"10034",name:"鸡你太美",influencePrice:50,findExplain:["喜欢坤坤真的泰裤啦"]},

            {id:"10041",name:"答辩",influencePrice:-50,findExplain:["不好意思啊，刚刚用了忘记擦干了"]},
            {id:"10042",name:"尿字",influencePrice:-10,findExplain:["尿壶肯定是尿字啊"]},
            {id:"10043",name:"破洞",influencePrice:-200,findExplain:["用力过大了，不小心冲了个洞"]},

            {id:"10051",name:"破洞",influencePrice:-30,findExplain:["谁家盔甲穿久了还没个破洞啊"]},
            {id:"10052",name:"破布",influencePrice:-50,findExplain:["外表好看就好啦，在乎那么多细节干什么"]},
            {id:"10053",name:"掉漆",influencePrice:-800,findExplain:["你回去补补就没事了"]},
            {id:"10054",name:"猪头",influencePrice:-200,findExplain:["这是当地的特色啦"]},

            {id:"10061",name:"天子王玺",influencePrice:-999,findExplain:["我一个皇亲国戚，还能卖你赝品不成？"]},
            {id:"10062",name:"鸡头",influencePrice:-600,findExplain:["什么年代了还弄传统龙头"]},
            {id:"10063",name:"售价88文",influencePrice:-200,findExplain:["这可是无价之宝，金钱衡量不了的"]},
            {id:"10064",name:"缺角",influencePrice:-300,findExplain:["这是我爷爷早朝时不小心敲掉一块，不影响使用"]},
        ];
    }
    return blemishAry;
}

let blemishMap:pawnShopGameBlemishMap = null;
//获取鉴宝中的瑕疵map
export function getPawnShopBlemishMap(){
    if(!blemishMap){
        blemishMap = <pawnShopGameBlemishMap>{}
        let ary = getPawnShopBlemishAry();
        for(let i =0;i<ary.length;i++){
            let blemish = ary[i];
            let id = blemish.id;
            blemishMap[id] = blemish;
        }
    }
    return blemishMap;
}
//通过一个id获取瑕疵
export function getOnePawnShopBlemishById(id:string){
    return getPawnShopBlemishMap()[id];
}

//购买的话术
export function getPawnShopBuyChat(){
    return [
        "老板我高价收购宝贝，我想买你的&",
        "老板你这里有没有值得收藏的宝贝，我想买你的&做传家宝！"
    ]
}
//出售的话术1
export function getPawnShopSellOneChat(){
    return [
        "我看你是这条街最识货的老板，这件宝贝你可千万不能错过啊",
        "我的老物件可不轻易示人的，你看看感兴趣吗？",
        "我这个可是家传秘宝， 要不是少路费了我才不卖，老板你瞅两眼？",
        "老板我带来了一个宝贝！你绝对会感兴趣！"
    ]
}
//出售的话术2
export function getPawnShopSellSecondChat(){
    return [
        "就知道你最识货了，我这宝贝只要$，你好好看看",
        "我这个老物件只要你$，怎么样？是不是物超所值？",
        "家传秘宝仅需$，你就跟我说实话，心动不心动？",
        "$，买到就是赚到",
    ]
}

export const pawnShopObjQualityExplainAry :string[] = [
    "破碎",
    "瑕疵",
    "完好",
    "极品"
]

export const pawnShopObjQualityColorStrAry:string[] = [
    "73A2B9",
    "817EDE",
    "11C25D",
    "EF851A"
]

export const pawnShopObjQualityColorAry:cc.Color[] = [
    cc.color(115,162,185),
    cc.color(129,126,222),
    cc.color(17,194,93),
    cc.color(239,133,26),
]

export const pawnShopObjPigmentCountAry:number[] = [
    1,
    2,
    3,
    4
];

export const pawnShopObjCanFixCountAry:number[][] = [
    [1,3],
    [2,5],
    [3,7],
    [4,9]
]

export const pawnShopFixGameObjExpendCount:number = 5;